import React from 'react';
import pricingData from '../../data/pricingData.js';

const Pricing = () => {
  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <h2 className="section-title">Pricing Packages</h2>
        <div className="pricing-grid">
          {pricingData.map((plan) => (
            <div key={plan.id} className={`pricing-card ${plan.package === 'Standard' ? 'featured' : ''}`}>
              <div className="pricing-header">
                <h3>{plan.package}</h3>
                <div className="pricing-price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-duration">{plan.duration}</span>
                </div>
              </div>
              <div className="pricing-features">
                <ul>
                  {plan.features.map((feature, index) => (
                    <li key={index} className="feature-included">
                      <span className="check-icon">✓</span>
                      {feature}
                    </li>
                  ))}
                  {plan.notIncluded.map((feature, index) => (
                    <li key={index} className="feature-excluded">
                      <span className="cross-icon">✗</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="pricing-footer">
                <a href="#contact" className={`btn ${plan.package === 'Standard' ? 'btn-primary' : 'btn-outline'}`}>
                  Choose Package
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
